import React from 'react';


const AboutMe = () => {
    return ( 
        <div className="AboutMeWrapper">
            <div className="title">
                <h1>Norbert Pietruszewski</h1>
                <h2>junior front-end developer</h2>
            </div>
            <div className="Aboutme">
                <p>Jestem początkującym front-end developerem. Jestem po technikum informatycznym, w którym również uczyłem się tworzenia stron internetowych. Więc można powiedziec że programowaniem pasjonuję się od dawna. </p>
                <p>Jako developer przywiązuje pełną uwagę do tego aby strony działały płynnie, były responsywne oraz estetyczne</p>
                <p>Aktualnie jestem w trakcie nauki Reacta, w którym stworzyłem te portfolio i szukam pracy bądź stażu na stanowisku front-end developera </p>
                <p>Moimi zainteresowaniami poza tworzeniem stron oczywiście, jest hobbistyczne strzelectwo oraz sport.</p>
            </div>
        </div>
     );
}
 
export default AboutMe;